import '@polymer/iron-ajax/iron-ajax';

import { PolymerElement, html } from '@polymer/polymer/polymer-element';

import { NebMapsApiMixin } from './neb-maps-api-mixin';
/**
 * Component for printing maps according to address.
 */

class NebMap extends NebMapsApiMixin(PolymerElement) {
  static get template() {
    return html`
      <style>
        #map {
          width: var(--neb-map-width, 100%);
          height: var(--neb-map-height, 100%);
        }
        #staticMap {
          cursor: pointer;
        }
      </style>
      <iron-ajax
        hidden
        id="ajax"
        url="[[_staticMapUrl]]"
        method="GET"
        on-response="_handleStaticMapsResponse"
        handle-as="blob"
      ></iron-ajax>
    `;
  }

  static get properties() {
    return {
      /**
       * True, only a simple image will be retrieved.
       */
      static: {
        type: Boolean,
        value: false,
      },

      /** The desired zoom level. */
      zoom: {
        type: Number,
        value: 13,
      },

      /**
       * The static map size
       */
      size: {
        type: String,
        value: '200x200',
      },
      address: String,
      city: String,
      state: String,
      zipCode: Number,
    };
  }

  static get observers() {
    return ['__initMap(initialized, address, city, state, zipCode)'];
  }

  _onLoad() {
    this.__geocoderService = new window.google.maps.Geocoder();
    this.initialized = true;
  }

  __initMap(initialized, address, city, state, zipCode) {
    if (!initialized || !address || !city || !state || !zipCode) {
      return;
    }

    const fullAddress = this._buildFullAddress(address, city, state, zipCode);

    if (this.static) {
      this._requestStaticMap(fullAddress);
    } else {
      this._buildMap(fullAddress);
    }
  }

  _buildFullAddress(address, city, state, zipCode) {
    const fullAddress = [];
    fullAddress.push(address);
    fullAddress.push(city);
    fullAddress.push(state);
    fullAddress.push(zipCode);
    return fullAddress.join(',');
  }

  _requestStaticMap(fullAddress) {
    const params = {
      center: fullAddress,
      scale: 1,
      size: this.size,
      zoom: this.zoom,
      markers: fullAddress,
      key: this._key,
    };
    this.$.ajax.params = params;
    this.$.ajax.generateRequest();
  }

  _handleStaticMapsResponse(e) {
    const { response } = e.detail;

    let imgElement = this.shadowRoot.querySelector('#staticMap');

    if (!imgElement) {
      imgElement = document.createElement('img');
      imgElement.setAttribute('id', 'staticMap');
      imgElement.addEventListener('click', () => {
        this._openMapUrl();
      });

      this.shadowRoot.appendChild(imgElement);
    }

    imgElement.src = URL.createObjectURL(response);
  }

  _buildMap(fullAddress) {
    let divElement = this.shadowRoot.querySelector('#map');

    if (!divElement) {
      divElement = document.createElement('div');
      divElement.setAttribute('id', 'map');
      this.shadowRoot.appendChild(divElement);
    }

    this.__geocoderService.geocode(
      {
        address: fullAddress,
      },
      (results, status) => {
        if (status === window.google.maps.GeocoderStatus.OK) {
          const map = new window.google.maps.Map(divElement, {
            center: results[0].geometry.location,
            zoom: this.zoom,
          });
          const marker = new window.google.maps.Marker({
            map,
            position: results[0].geometry.location,
          });
          marker.addListener('click', () => {
            this._openMapUrl();
          });
        }
      },
    );
  }

  _openMapUrl() {
    const fullAddress = this._buildFullAddress(
      this.address,
      this.city,
      this.state,
      this.zipCode,
    );

    const isApple =
      /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    const toolUrl =
      (isApple ? this._aMapsUrl : this._gMapsPlacesUrl) + fullAddress;
    window.open(toolUrl, '_blank');
  }
}

customElements.define('neb-map', NebMap);
